import Butter from 'buttercms';

const butter = Butter('3a837ec95b1ae6a9e3d61ff1fe4b0e9caeba793a');

export default butter;
